
import Map from 'ol/Map';
import * as ol_style from 'ol/style';
import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';
import { Vector as ol_layer_Vector } from 'ol/layer';
import { Vector as ol_source_Vector } from 'ol/source';
import { Point as ol_geom_Point } from 'ol/geom';
import MultiPoint from 'ol/geom/MultiPoint';
import { Circle as CircleStyle, Fill, RegularShape, Stroke, Style, Text } from 'ol/style';

import { FrCoordinate, FrLayer } from 'gmap';
import { Panel } from 'solar-bo';
import { IItemDrawConfig } from 'gmap';


export class MapPanelStyle {

  panelStyle: any[] = [];
  panel_pattern:string;

  // map:Map;
  constructor() {
    //   this.map=mapc.map;
    this.configurePanelStyle();
  }
  panelStyleBorder:any
  panel_fill: any;
  panel_stroke: any;

  /**
   * cache stroke, fills, etc
   */
  issueCacheDrawOptions: IItemDrawConfig[] = [];

  configurePanelStyle() {

    this.panel_stroke = new ol_style.Stroke({
      color: 'rgb(23, 203, 248)',
      width: 1
    });
    this.panel_fill = new Fill({
      color: 'rgba(220, 53, 53, 0.1)'
    });

    this.panelStyleBorder = new ol_style.Style({
      stroke: this.panel_stroke
      , fill: this.panel_fill
    });

  }


  issueNameStroke = new ol_style.Stroke({
    color: [255, 255, 255, 1],
    width: 5
  });

  issueNamefill = new ol_style.Fill({
    color: [0, 0, 0, 1]
  });
  /**
   * Style for issues
   * @param feature 
   * @param resolution 
   */
  panelsFilterStyle(feature, resolution) {

    //console.log("panelsFilterStyle resolution: " + resolution);
    try {
      const extInfo: FrLayer = feature.frlayerinfo;
      let panel:Panel;
      let locatorDesc:string=extInfo.name;
      
      if (extInfo && extInfo.refObject){
        //must be a panel with locator
        panel=extInfo.refObject;
        locatorDesc =panel.mapLocator;//MapSupervisionHelper.locatorGetFormatedDescByPattern(panel, this.panel_pattern);
      }
      let scaleSize = 0.9;// Math.floor(resolution * 10000000000);

      let styles = [];
      styles.push(this.panelStyleBorder);
      if (resolution<1.68e-7 && locatorDesc){
        let textStyle = new ol_style.Text({
          text: locatorDesc
          , font: 'bold 11px Calibri,sans-serif'
          , scale: scaleSize
          , fill: this.issueNamefill,
          stroke: this.issueNameStroke
        })        
        let style2 = new ol_style.Style({
          text: textStyle
        });      
        styles.push(style2);        
      }


      return styles;
    }
    catch (err) {
      console.log(err);
    }
  }
}